export const SAVE_ALL_VEHICLES = 'SAVE_ALL_VEHICLES'
export const SAVE_VEHICLE = 'SAVE_VEHICLE'
